try {
    require('raygun4js');
} catch(e) {
    console.warn("Running without Raygun error logging");
}

var Recorder = require("./event.js").Recorder;
var ErrorHelper = require("cio-config").ErrorHelper;

// NOTE that blocking errors cannot be closed. (Unlike critical which causes refresh on close)
// I don't think there is any situation now that requires this type of error.
// we should not use it unless that changes.
var accepted_criticalities = {
    TRIVIAL : 'trivial error',
    MINOR : 'minor error',
    MAJOR : 'major error',
    CRITICAL : 'critical error',
    BLOCKING : 'blocking error'
};

var criticalities_priority_order = [
    accepted_criticalities.TRIVIAL,
    accepted_criticalities.MINOR,
    accepted_criticalities.MAJOR,
    accepted_criticalities.CRITICAL,
    accepted_criticalities.BLOCKING
];

var isAcceptableCriticality = function(criticality) {
    if(criticality === accepted_criticalities.TRIVIAL) return true;
    if(criticality === accepted_criticalities.MINOR) return true;
    if(criticality === accepted_criticalities.MAJOR) return true;
    if(criticality === accepted_criticalities.CRITICAL) return true;
    if(criticality === accepted_criticalities.BLOCKING) return true;
    return false;
};

var isMoreCriticalThan = function(cr1, cr2) {
    return criticalities_priority_order.indexOf(cr1) > criticalities_priority_order.indexOf(cr2);
};

var getMessage = function(location, context, error, criticality, additionalData, isServerError, willBeConcatinated, isExpectedError) {
    if(isServerError) {
        return ErrorHelper.csErrorString(error["status"], error["responseText"], context, additionalData);
    } else {
        return ErrorHelper.exceptionErrorString(error.message, error.stack, location, context, willBeConcatinated, isExpectedError);
    }
}

// note that 'location' will not be displayed with an 'expected error'
var logError = function(location, error, criticality, context, isExpectedError, additionalData) {

    if(criticality == undefined) {
        console.warn('Error logged without criticality, assuming "major error"');
        criticality = accepted_criticalities.MAJOR;
    }
    if(!isAcceptableCriticality(criticality)) {
        console.warn('Error logged with invalid criticality, assuming "major error"');
        criticality = accepted_criticalities.MAJOR;
    }

    var serverResponseError = false;
    if(error["status"] !== undefined) serverResponseError = true;

    // There are often cases where i want to have multiple catches, one catch that is very specific (this specific thing failed) 
    // and one higher up in the promise chain that is more broad (this action failed to happen). This is useful because
    // if something outside of the specific catch happens, it still gets caught by the broader catch, but i have the ability to add in specificity, 
    // without having to worry about the error getting logged twice as it gets thrown up the promise chain.
    // If I want a different error to get thrown AFTER the initial has been thrown (or ignored) I can always just create a new error. 
    if(error.logged) return;
    else error.logged = true;

    if (typeof(window) !== 'undefined') {

        if (window['CircuitsRecorder']) window['CircuitsRecorder'].storeException(context, error);

        //Display error to user
        if(window.errorMessageModel)

            var willBeConcatinated = window.errorMessageModel.willBeConcatinated(error, isExpectedError); 

            window.errorMessageModel.logErrorMessage({
                title: "Error",
                message: getMessage(location, context, error, criticality, additionalData, serverResponseError, willBeConcatinated, isExpectedError), // + /*'<BR/>' + error.toString() +*/ '<BR/>This error has been reported.',
                criticality: criticality,
                isExpectedError: isExpectedError
            }, willBeConcatinated);

        //Log error to console
        if ( error.stack) {
            console.error(error.stack);
        }

        //Log error to Raygun    ---- REMOVED FOR GDPR
        // try {
        //     var custom_data = additionalData;
        //     custom_data["context"] = context;
        //     custom_data["location"] = location;

        //     if(error.data)
        //         custom_data['data'] = error.data;
        //     if(error["status"])
        //         custom_data['status'] = error["status"];
        //     if(error["responseText"])
        //         custom_data['responseText'] = error["responseText"];

        //     Raygun.send(error, custom_data, [criticality]);
        // } catch (f) {
        //     console.error(error.stack);
        //     console.error('Raygun error logging failed: '+f);
        // }
    } else {
        console.error(error.stack);
    }

    if(logError.rethrow)
        throw error;
};
if ('undefined' !== typeof window) {
    window['logError'] = logError;
}


logError.criticality = accepted_criticalities;
logError.isMoreCriticalThan = isMoreCriticalThan;

logError.rethrow = false;

module.exports = logError;
